import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { allevaSlateColor, allevaOrangeColor } from '../md/assets/jss/material-dashboard-pro-react';

import AlertsPanel from '../components/AlertsPanel';
import DefaultDropdownValuesPanel from '../components/DefaultDropdownValuesPanel';
import SystemInfoPanel from '../components/SystemInfoPanel';
import FirmUsersOverview from '../components/FirmUsersOverview';
import DropdownEditor from './DropdownEditor';
import DropdownEditor02 from './DropdownEditor02';

function TabPanel(props) {
  const { children, value, index } = props;

  return <div hidden={value !== index}>{children}</div>;
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabs: {
    color: '#fff',
    backgroundColor: allevaSlateColor,
  },
  tabSelected: {
    color: allevaOrangeColor,
  },
  tabUnselected: {
    color: '#aaa',
  },
});

class SettingsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabI: 0,
    };
  }

  handleTabChange(event, value) {
    this.setState({ tabI: value });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    const { classes, userInfo } = this.props;
    const { tabI } = this.state;
    const isAdmin = userInfo.role === 'Admin';

    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Tabs className={classes.tabs} value={tabI} onChange={(event, value) => this.handleTabChange(event, value)}>
            <Tab className={tabI === 0 ? classes.tabSelected : classes.tabUnselected} label="System Info" />
            <Tab className={tabI === 1 ? classes.tabSelected : classes.tabUnselected} label="Alerts" />
            <Tab className={tabI === 2 ? classes.tabSelected : classes.tabUnselected} label="Dropdown Defaults" />
            {isAdmin && <Tab className={tabI === 3 ? classes.tabSelected : classes.tabUnselected} label="Users" />}
            {isAdmin && (
              <Tab className={tabI === 4 ? classes.tabSelected : classes.tabUnselected} label="Edit Dropdowns" />
            )}
            {false && isAdmin && (
              <Tab className={tabI === 5 ? classes.tabSelected : classes.tabUnselected} label="Edit Dropdowns_old" />
            )}
          </Tabs>
        </AppBar>
        <TabPanel value={tabI} index={0}>
          <SystemInfoPanel />
        </TabPanel>
        <TabPanel value={tabI} index={1}>
          <AlertsPanel />
        </TabPanel>
        <TabPanel value={tabI} index={2}>
          <DefaultDropdownValuesPanel />
        </TabPanel>
        <TabPanel value={tabI} index={3}>
          <FirmUsersOverview />
        </TabPanel>
        <TabPanel value={tabI} index={4}>
          <DropdownEditor02 />
        </TabPanel>
        {false && (
          <TabPanel value={tabI} index={5}>
            <DropdownEditor />
          </TabPanel>
        )}
      </div>
    );
  }
}

SettingsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});

const actionProducers = {};

export default connect(mapStateToProps, actionProducers)(withStyles(styles)(SettingsPage));
